<template>
  <navigation-button @navigate-clicked="$emit('navigate-clicked')" button-text="חיסכון בקופת גמל להשקעה" v-if="!promotionByHarel && !showSavingZone"
                     image-path="nav/trophy.svg" :show-expand="false"></navigation-button>
</template>

<script>

import NavigationButton from '@/base-components/app-header/NavigationButton';
import CustomerBenefits from '@/mixins/CustomerBenefits';

export default {
  name: 'SavingsNavigationButton',
  components: { NavigationButton },
  mixins: [CustomerBenefits],
  data() {
    return {
      showSavingZone: true,
    };
  },
};
</script>
